<template>
    <div class='tw-flex tw--mx-20'>
        <div class="px-3 tw-w-2/3">
            <process-model-stepper :current-step="3">
			</process-model-stepper>
			<div class="nqt-container mt-3">
				<process-list-employee-for-evaluation
					class="employeList mx-3"
					:rows="employeesList"
					:disabled-assign="btnSave"
					:total-items-visible="7"
					:total-items="totalItems"
					:last-page="lastPage"
					:current-page="currentPage"
					@changeSort="changeSort"
					@click-icon="iconAction"
					@save-process="saveEvaluatorsProcess"
					@on-page="changePage"
					@on-search-event="onSearchEvent"
					>
				</process-list-employee-for-evaluation>
				<div class="nqt-btn"
					:style="`border-top:1px solid ${$appColors.gray};`">
					<v-btn
						color="primary"
						class="btn-action"
						@click="returnPage"
					>
						Atrás
					</v-btn>
					<v-btn
						:disabled="!btnPublish"
						color="primary"
						class="btn-action"
						@click="publicProcess"
					>
						Publicar
					</v-btn>
				</div>
			</div>
        </div>
		<div class="tw-w-1/3 px-3">
			<process-model-description-evaluator v-if="!viewEvaluators">
			</process-model-description-evaluator>
			<table-choose-evaluators v-else
				class="employeList mx-3"
				:employee="selectEmp"
				:index-employee="indexEmployee"
				:checkAll="checkAll"
				@changeSort="changeSort"
				@view="viewTableEvaluator"
				@select-evaluator="assingEvaluators"
				@btn-save="btnSaveEval"
				@btn-disable="btnDisable">
			</table-choose-evaluators>
		</div>
		<confirm-dialog ref="confirmDialog" />
    </div>
</template>

<script>
import processModelStepper from '@/modules/evaluation-360/components/process/process-model-stepper';
import processModelDescriptionEvaluator from '@/modules/evaluation-360/components/process/process-model-description-evaluator';
import processListEmployeeForEvaluation from '@/modules/evaluation-360/components/process/process-list-employee-for-evaluation';
import tableChooseEvaluators from '@/modules/evaluation-360/components/process/table-choose-evaluators';
import ConfirmDialog from '@/modules/shared/components/ui/ConfirmDialog';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { pathOr } from 'ramda';

const { getLocalData } = helper;

function created() {
	this.loadEmployeeSelect();
	this.idEditProcess = this.$route.params.id;
	if (this.idEditProcess) {
		this.loadProcess(this.idEditProcess);
	}
}

async function loadProcess(id) {
	try {
		const { data: response } = await this.$httpPraktiko.get(`process/detail/${id}`);
		this.$store.dispatch('evaluation360/assignProcess', response);
	} catch (error) {
		this.showGenericError(error);
	}
}

function getLocalProcess() {
	const processData = getLocalData('process');
	return processData;
}

async function loadEmployeeSelect() {
	const params = {
		...this.params,
	};
	try {
		let process = null;
		if (this.process === null) {
			process = this.getLocalProcess();
		}
		const id = this.process ? this.process.id : process.id;
		const { data: response, headers } = await this.$httpPraktiko.get(`process/employees/${id}`, { params });
		this.employeesList = response;
		this.lastPage = Number(headers['x-last-page']);
		this.totalItems = Number(headers['x-quantity']);
		// if (this.employeesAsignId.length > 0) {
		// 	this.employeesList.forEach((employee, index) => {
		// 		const employeeId = employee.employeeId;
		// 		const matchEmployeeId = this.employeesAsignId.find(e => e.employeeId === employeeId);
		// 		if (matchEmployeeId) {
		// 		} else {
		// 			const updateEmployee = { ...employee };
		// 			updateEmployee.evaluators.employees = [];
		// 			this.employeesList[index] = updateEmployee;
		// 		}
		// 	});
		// }
	} catch (error) {
		this.showGenericError();
	}
}

function changeSort({ fieldName, sortDirection }) {
	this.params.tableName = fieldName;
	this.params.sortDirection = sortDirection;
	this.loadEmployeeSelect();
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadEmployeeSelect();
}

function onSearchEvent(search) {
	this.params.search = search.trim() || null;
	this.changePage(1);
}

function totalItemsVisible() {
	return this.employees.length;
}

function iconAction(item) {
	if (item.action === 'select') {
		this.selectEvaluatorView(item.row);
		this.indexEmployee = item.index;
	} else if (item.action === 'delete') {
		this.deleteEmployeeForEvaluation(item.row);
	}
}

async function deleteEmployeeForEvaluation(item) {
	this.$refs.confirmDialog.showConfirm({
		onOk: async () => {
			try {
				const { id, processId } = item;
				await this.$httpPraktiko.delete(`process/delete-process-employee/${processId}/${id}`);
				this.showNotification('Registro eliminado correctamente.');
				this.loadEmployeeSelect();
			} catch (error) {
				this.showGenericError();
			}
		},
		title: `¿Seguro que desea eliminar a ${item.employee.name} ${item.employee.lastName}  de la lista?`,
	});
}

function selectEvaluatorView(employee) {
	this.selectEmp = employee;
	this.viewEvaluators = true;
}

function viewTableEvaluator() {
	this.viewEvaluators = false;
}
function btnDisable(value) {
	this.btnPublish = value;
	if (!this.btnPublish) {
		this.showNotification('Recuerde grabar las elecciones para registrar la información', 'warning');
	}
}

function assingEvaluators({ employee, index }) {
	this.employeesList[index] = employee;
}

async function saveEvaluatorsProcess(item) {
	const disableBtnP = item.some(i => Object.keys(i.evaluators).length === 0);
	const employeesAsignEvaluators = item.filter(i =>
		i && i.evaluators && i.evaluators.employees && i.evaluators.employees.length > 0)
		.map((f) => {
			const newF = { ...f };
			delete newF.isChecked;
			return newF;
		});
	try {
		const body = {
			processEvaluators: employeesAsignEvaluators,
		};
		await this.$httpPraktiko.patch(`process/evaluators/${this.process.id}`, body);
		this.showNotification('Evaluadores Guardados Exitosamente');
		this.employeesAsignId = employeesAsignEvaluators;
		this.loadEmployeeSelect();
		this.viewEvaluators = false;
		if (disableBtnP) {
			this.btnPublish = false;
			this.showNotification('RECUERDA: Para publicar el proceso todos los evaluados deben contar con evaluadores', 'warning');
		} else {
			this.btnPublish = true;
		}
	} catch (error) {
		this.showGenericError();
		this.btnPublish = false;
	}
}

async function publicProcess() {
	try {
		await this.$httpPraktiko.patch(`process/publish/${this.process.id}`);
		this.showNotification('Proceso Publicado Exitosamente');
		this.goTo('list-process');
	} catch (error) {
		this.showGenericError(error);
	}
}

function returnPage() {
	if (this.idEditProcess) {
		this.goTo('edit-choose-employees');
	} else {
		this.goTo('process-choose-employees');
	}
}

function btnSaveEval(value) {
	this.btnSave = value;
}

function data() {
	return {
		employeesList: [],
		viewEvaluators: false,
		selectEmp: [],
		checkAll: false,
		indexEmployee: null,
		idEditProcess: null,
		btnPublish: false,
		btnSave: false,
		employeesAsignId: [],
		indexSelect: null,
		params: {
			page: 1,
			limit: 10,
			// sortField: null,
			tableName: null,
			sortDirection: null,
		},
		lastPage: 0,
		totalItems: 0,
		currentPage: 1,
	};
}
export default {
	name: 'page-choose-evalators',
	data,
	created,
	components: {
		processModelStepper,
		processModelDescriptionEvaluator,
		processListEmployeeForEvaluation,
		tableChooseEvaluators,
		ConfirmDialog,
	},
	methods: {
		loadEmployeeSelect,
		changePage,
		onSearchEvent,
		iconAction,
		deleteEmployeeForEvaluation,
		selectEvaluatorView,
		viewTableEvaluator,
		assingEvaluators,
		saveEvaluatorsProcess,
		publicProcess,
		getLocalProcess,
		returnPage,
		btnDisable,
		btnSaveEval,
		changeSort,
		loadProcess,
	},
	computed: {
		...mapState('evaluation360', {
			process:
			pathOr(null, ['process']),
		}),
		totalItemsVisible,
	},
};
</script>

<style lang="scss" scoped>
.nqt-container {
	display: flex;
	flex-direction: column;
	justify-content: space-bewteen;
	width: 100%;
	border: 1px solid #E9E9E9;
	background-color: map-get($colors, white);
	border-radius: 8px;
	.nqt-btn {
		align-items: center;
		display: flex;
		justify-content: center;
		gap: 10px;
		padding: 20px 30px;
	}

}
.employeList {
	@media (max-width: 950px) {
			width: 700px;
			display: flex;
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/pages/process-steps-pages/page-choose-evaluators.vue